$(document).ready(function() {
	if(!document.querySelector('.GPC0030')) return false;

	var c = {
		el: null,
		tab : null,
		template: null,
		init: function(){
			var _this = c;
			var els = document.querySelectorAll('.GPC0030');

			for (var i = 0; i < els.length; i++) {
				_this.el = els[i];
				_this.tab = _this.el.querySelector('.tabs-type-liner');
				_this.template = $(_this.el).find('.contents-template').clone();
				_this.pageTemplate = $(_this.el).find('#paginationTemplate').clone();
				$(_this.el).find('.contents-template').remove();
				$(_this.el).find('#paginationTemplate').remove();
				
				_this.addEvent();
				_this.addAriaDescribedby();
				if(_this.tab && !$(_this.tab.querySelector('a')).is('.active')) {
					$(_this.tab.querySelector('a')).trigger('click');
				}
				// 20200514 START 박지영 - 페이지 1개 뿐일때 expander 삭제 (for 모바일)
				if($(_this.el).find('.pagination').eq(0).find('ul li').length<=1) {
					// more button 
					$(_this.el).find('.expander').hide();
				}
				// 20200415 END
			}
			// 20200406 START 이상현 - tab ui의 관계 정보 추가
			_this.addAriaRelationship(els);
			// 20200406 END
			
			/* LGEPL-555 Start */
			if(COUNTRY_CODE == 'pl'){
				var tabJson = {}
				if(!!$(_this.el).data('tab-id')){
					if(!!$(_this.el).data('tab-id').length && $(_this.el).data('tab-id') != 'component-promotion-tab-id'){
						$(_this.el).data('tab-id').split(',').map(function(item){
						    var jsonText =item.split(':');
						    tabJson[ $.trim(jsonText[0])] = $.trim(jsonText[1])    
						})
						var u = window.location.href;
						if(u.indexOf("?") > 0){
					        path = u.substr(0 , u.indexOf("?"));        
					        query = u.substr(u.indexOf("?") + 1);
					        params= query.split('&'); 
					        params.map(function(param){
					        	var tabId = tabJson[param.split('tab_name=')[1]];
					        	if(!!tabId) {
					        		$(_this.tab).find('a.btn-tab[href="#'+tabId+'"]').click();
					        		
					        		$(document).ready(function(){
					        			setTimeout(function(){
					        				$(window).scrollTop($(_this.el).offset().top);
					        			}, 1500);
					        		});
					        	}
					        })
					    }
					}	
				}
			}
			/* LGEPL-555 End */
		},
		createProductItem: function(productList){
			var html = [];
			for (var i = 0; i < productList.length; i++) {
				var p = productList[i],
				template = $(c.template).clone().html();
				template = template.replace(/\*promotionLinkUrl\*/g, p.promotionLinkUrl)
								.replace(/\*title\*/g, p.title)
								.replace(/\*thumbnailImageAddr\*/g, p.thumbnailImageAddr)
								.replace(/\*imageAltText\*/g, (p.imageAltText != null) ? p.imageAltText : '')
								.replace(/\*adobePromotionTitle\*/g, p.adobePromotionTitle)
								.replace(/\*promotionStartDate\*/g, p.promotionStartDate)
								.replace(/\*promotionEndDate\*/g, p.promotionEndDate);
								//LGEDE-63 START
								//.replace(/\*bodyCopyText\*/g, p.bodyCopyText);
								//LGEDE-63 END
				//PJTPROMOAF-3 START
				var tagBoxHtml = "";
				var bodyCopyTextHtml = "";
				if(p.promotionListTag != "" || p.memberType == "Y"){
					tagBoxHtml += "<div class='tag-copy'>"
					if(p.promotionListTag != ""){
						tagBoxHtml += "<span class='fill'>"+p.promotionListTag+"</span>";
					}
					if(p.memberType == "Y"){
						var promotionForMember = typeof $('input[name=promotionForMember]').val() =='undefined' ? "FOR MEMBERS" : $('input[name=promotionForMember]').val();
						tagBoxHtml += "<span>"+promotionForMember+"</span>";
					}
					tagBoxHtml += "</div>"
				}
				template = template.replace(/\*tagCopyBox\*/g, tagBoxHtml);
				
				if(p.bodyCopyUseFlag == "Y"){
					bodyCopyTextHtml += "<p class='body-copy-desc'>"+p.bodyCopyText+"</p>";
				}
				template = template.replace(/\*bodyCopyText\*/g, bodyCopyTextHtml);
				//PJTPROMOAF-3 END
				
				// LGEBR-1248 start
				if( p.promotionDateDisplayFlag == "N"){
					template = template.replace(p.promotionStartDate+" ~ "+p.promotionEndDate,"&nbsp;");
				}
				// LGEBR-1248 end				

				var $template = $(template),
					$keyBlocks = $template.find('*[data-key]');

				for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
					var $currentKeyBlock = $keyBlocks.eq(i1),
						key = $currentKeyBlock.get(0).getAttribute('data-key'),
						val = p[key];
					if(!val || (val == null || val == "N")) {
						if($currentKeyBlock.is('.btn')) {
							$currentKeyBlock.removeClass('active');
						}else {
							$currentKeyBlock.remove();
						}
					}
				}

				if(p.externalLinkTarget && p.externalLinkTarget=="New") {
					$template.find('.visual-area a').attr('target', '_blank');
					$template.find('.btn-box a.btn').attr('target', '_blank');
				}

				$template.find('template').remove();
				if(i == 0){ // accessiblity focus item
					$template.addClass('first-item');
				}
				template = $template.get(0).outerHTML;
				html += template;
			}

			return html;
		},
		addAriaDescribedby: function(){
			var waNumber = 0;
			$('.GPC0030').find('.unit-list .unit-box').each(function() {
				var $target;
				if($(this).find('.head-copy') && !$(this).find('.head-copy').is(':empty')) {
					$target = $(this).find('.head-copy');
				}
				if($target) {
					$target.attr('id', 'waGPC0030_'+waNumber);
					$(this).find('a.btn').attr('aria-describedby', 'waGPC0030_'+waNumber);
					waNumber++;
				}
			});
		},
		// 20200406 START 이상현 - tab ui의 관계 정보 추가
		addAriaRelationship : function(tg){
			if($(tg).find('.js-tab').length > 0){
				$(tg).find('.js-tab').find('[role="tab"]').each(function(idx) {
					$(this).attr('id', 'tabLabel_' + (idx+1));
					$(tg).find('[role="tabpanel"]').eq(idx).attr('aria-labelledby', 'tabLabel_' + (idx+1));
				});
			}
		},
		// 20200406 END
		addEvent: function(){
			var _this = c;
			$(_this.el).on({
				submit: function(e, isTabEvent){
					e.preventDefault();
					var isExpander = $(e.delegateTarget).data('focus') == true;
					var url = e.currentTarget.action,
						param = xssfilter($(e.currentTarget).serialize());
					var $target = $(e.currentTarget).siblings('.list-contents-wrap');
					// check initialize
					var isInit = !$target.is('.initialized') && $target.closest('.contents-area').is(":first-child");
					// 20200506 START 이상현 - promotion 제품 없을 시 화면 추가
					var $form = $(this);
					// 20200506 END
					ajax.noCacheCall(url, param, 'json', function(d){
						var data, html;
						if(d && d.data) data = d.data instanceof Array ? d.data[0] : d.data;

						// 20200506 START 이상현 - promotion 제품 없을 시 화면 추가
						if(d.status == "success" && (data && data.promotionList && data.promotionList.length > 0) ) {
						// 20200506 END
							// making markup
							html = c.createProductItem(data.promotionList);
							// append markup
							var pageInfo = data.pageInfo;
							if(isExpander) {
								$target.find('.pagination').hide();
								$target.find('.unit-list').append(html);
								var pageVisible = pageInfo && pageInfo.view == "Y";
								if(pageVisible && pageInfo.page < pageInfo.pageCount) {
									$target.find('.expander button').get(0).value = pageInfo.page+1;
									$target.find('.expander').show();
								}else {
									$target.find('.expander').hide();
								}
							}else {
								$target.find('.expander').hide();
								$target.find('.unit-list').html(html);
								c.addAriaDescribedby();
								// setting pagination
								if(pageInfo && pageInfo.view == "Y") {
									if($target.find('.pagination').get(0)){
										var pageMarkup = [];
										for (var pageIdx = pageInfo.loopStart; pageIdx <= pageInfo.loopEnd; pageIdx++) {
											var _pageItem = _this.pageTemplate.clone().html();
											_pageItem = $(_pageItem).get(0),
											_pageButton = _pageItem.querySelector('button');
											_pageButton.value = pageIdx;
											_pageButton.innerHTML = pageIdx;
											if(pageIdx.toString() == pageInfo.page) {
												_pageButton.setAttribute('class', 'active');
												// WA-GPC0030-06 : aria-current 추가
												_pageButton.setAttribute('aria-current', 'page');
											}
											if($target.find('.pagination').attr('data-aria-pattern')) {
												var _ariaText = $target.find('.pagination').attr('data-aria-pattern').replace(/\#/g, pageIdx);
												_pageButton.setAttribute('aria-label', _ariaText);
											}
											pageMarkup += _pageItem.outerHTML;
										}
										$target.find('.pagination ul').html(pageMarkup);

										$target.find('.pagination .prev').get(0).disabled = !pageInfo.leftPage;
										$target.find('.pagination .next').get(0).disabled = !pageInfo.rightPage;
										$target.find('.pagination .prev').get(0).value = pageInfo.page-1;
										$target.find('.pagination .next').get(0).value = pageInfo.page+1;
										$target.find('.pagination').show();
									}
									if(isMobile && pageInfo.loopStart != pageInfo.loopEnd) {
										$target.find('.pagination').hide();
										$target.find('.expander').show();
									}
								}else {
									$target.find('.pagination').hide();
								}

								if($target.hasClass('initialized')) {
									$('html, body').animate({
										scrollTop: $target.closest('.component').offset().top
									});
								}
							}

							if(!isTabEvent) {
								var $focusItem = $target.find(".first-item");
								$($focusItem).find("a").eq(0).focus();
								$($focusItem).removeClass("first-item");
							}

							$target.addClass('initialized');
						// 20200506 START 이상현 - promotion 제품 없을 시 화면 추가
						}else {
							$target.closest(".component").find(".no-content-wrap").addClass("active");
							$form.trigger('ajaxLoadEnd');
						}
						// 20200506 END
					});
				}
			}, 'form');

			// tab click
			$(_this.tab).on({
				click: function(e){
					e.preventDefault();
					var target = $(e.currentTarget.getAttribute('href')).get(0),
						targetForm = target.querySelector('form');

					if(!$(target.querySelector('.list-contents-wrap')).is('.initialized')) {
						$(targetForm).trigger('submit', [true]);
					}
				}
			}, 'a');

			// page click
			$(_this.el).on({
				click: function(e){
					e.preventDefault();
					var page = e.currentTarget.value,
						targetForm = $(e.currentTarget).closest('.contents-area').find('form').get(0),
						_del = e.delegateTarget;

					targetForm.page.value = page;

					if($(e.currentTarget).closest('.expander')[0]) {
						$(_del).data('focus', true);
					}else {
						$(_del).data('focus', false);
						var pagePosition = "";
						if($(e.currentTarget).is(".prev")) {
							pagePosition = "L";
						}else if($(e.currentTarget).is(".next")){
							pagePosition = "R";
						}
						targetForm.pagePosition.value = pagePosition;
					}

					$(targetForm).trigger('submit', [false]);
				}
			}, '.pagination button, .expander button');
		}
	};

	c.init();
	
	//PJTPROMOAF-3 START
	window.onhashchange = function() {
		var tabId = window.location.hash;

		if($(tabId).length > 0 && tabId.match('#pt')){
				var offsetTab;
				if(tabId == '#ptPakageDeal'){
					offsetTab = $(tabId).offset();
				}else{
					$(tabId+' a').trigger("click");
					offsetTab = $(tabId+' a').offset();
				}
				$('html').animate({scrollTop : offsetTab.top});
				window.location.hash = '';
		}
	};
	
	if(window.location.hash != '' && $('.tab-outer').length > 0){
		var tabId = window.location.hash;

			if($(tabId).length > 0 && tabId.match('#pt')){
					var offsetTab;
					if(tabId == '#ptPakageDeal'){
						offsetTab = $(tabId).offset();
					}else{
						$(tabId+' a').trigger("click");
						offsetTab = $(tabId+' a').offset();
					}
					$('html').animate({scrollTop : offsetTab.top});
					window.location.hash = '';
			}
	}
	//PJTPROMOAF-3 END
});